import { createRouter, createWebHistory, Router } from 'vue-router';
import { AppRoutes } from '@/router/app';

const routes = [
  {
    ...AppRoutes.EXPLORE,
    component: () => import('@/views/Explore/Explore.vue'),
  },
  {
    ...AppRoutes.MY_DOCS,
    component: () => import('@/views/MyDocs/MyDocs.vue'),
  },
  {
    ...AppRoutes.MIGRATED_DOCS,
    component: () => import('@/views/MigratedDocs/MigratedDocs.vue'),
  },
  {
    ...AppRoutes.QUESTIONNAIRE,
    component: () => import('@/views/Questionnaire/Questionnaire.vue'),
  },
  {
    ...AppRoutes.DISCLAIMER,
    component: () => import('@/views/Disclaimer/Disclaimer.vue'),
  },
  {
    ...AppRoutes.PRIVACY_POLICY,
    component: () => import('@/views/PrivacyPolicy/PrivacyPolicy.vue'),
  },
  {
    ...AppRoutes.TERMS_AND_CONDITIONS,
    component: () => import('@/views/TermsAndConditions/TermsAndConditions.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: AppRoutes.EXPLORE.path,
  },
];

const router: Router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (
      -1 < [AppRoutes.DISCLAIMER.path, AppRoutes.TERMS_AND_CONDITIONS.path].indexOf(to.path)
      && to.hash
    ) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }

    return { top: 0 };
  },
});

export default router;
